module.exports = __webpack_public_path__ + "static/12-3-1f9615f4ea4c232230e44e6fff9ab9d1.jpg";